import React, { useId, useState, useEffect } from 'react'
import {
	ClusterDescriptionLabelScrollContainer,
	ClusterDescriptionLabelText,
} from './ClusterDescriptionLabel.style'
import { Tooltip } from '@mui/material'
import { useClusterLabelDragScroll } from '../../hooks/useClusterLabelDragScroll'
import { CLUSTERS_CONTAINER_ID } from '../../pages/Clusters/Clusters'

interface ClusterDescriptionLabelProps {
	clusterLabel: string
	variant?: 'light' | 'dark'
	showTooltip?: boolean
}

const ClusterDescriptionLabel: React.FC<ClusterDescriptionLabelProps> = ({
	clusterLabel,
	variant = 'light',
	showTooltip = true,
}) => {
	const uniqueId = useId()
	const elementId = `cluster-label-${uniqueId}`
	const [isMobile, setIsMobile] = useState(window.innerWidth < 1440)

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 1440)
		}

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	useClusterLabelDragScroll(elementId, CLUSTERS_CONTAINER_ID)

	const shouldDisableTooltip =
		!showTooltip || isMobile || clusterLabel.length <= 33

	return (
		<ClusterDescriptionLabelScrollContainer
			id={isMobile ? elementId : undefined}
		>
			<Tooltip
				title={clusterLabel}
				placement="top"
				arrow
				disableHoverListener={shouldDisableTooltip}
				disableTouchListener={shouldDisableTooltip}
				PopperProps={{
					// I've used Number.MAX_SAFE_INTEGER because elsewhere in the project
					// it has been used for the CompareCluster modal, so without this
					// solution the tooltip would not be visible in that component
					sx: { zIndex: Number.MAX_SAFE_INTEGER },
				}}
				componentsProps={{
					tooltip: {
						sx: {
							bgcolor: variant === 'dark' ? 'common.black' : 'common.white',
							color: variant === 'dark' ? 'white' : 'black',
							fontSize: '1rem',
							fontWeight: 400,
							borderRadius: 2,
							boxShadow: 'none',
							outline: `1px solid ${variant === 'dark' ? 'black' : 'white'}`,

							'& .MuiTooltip-arrow': {
								color: variant === 'dark' ? 'common.black' : 'common.white',
								'&::before': {
									boxShadow: 'none',
								},
							},
						},
					},
				}}
			>
				<ClusterDescriptionLabelText variant={variant}>
					{clusterLabel}
				</ClusterDescriptionLabelText>
			</Tooltip>
		</ClusterDescriptionLabelScrollContainer>
	)
}

export default ClusterDescriptionLabel
